// extracted by mini-css-extract-plugin
module.exports = {"list":"VariantSelector_list__V6dOi","option":"VariantSelector_option__HWf3q"};